import React from 'react';
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
  LabelList,
} from 'recharts';

// Your yearly data
const data = [
  { month: 'Jan', rescuecount: 12, draftcount: 12 },
  { month: 'Feb', rescuecount: 15, draftcount: 8 },
  { month: 'Mar', rescuecount: 20, draftcount: 10 },
  { month: 'Apr', rescuecount: 18, draftcount: 14 },
  { month: 'May', rescuecount: 25, draftcount: 20 },
  { month: 'Jun', rescuecount: 22, draftcount: 18 },
  { month: 'Jul', rescuecount: 28, draftcount: 24 },
  { month: 'Aug', rescuecount: 30, draftcount: 28 },
  { month: 'Sep', rescuecount: 24, draftcount: 18 },
  { month: 'Oct', rescuecount: 26, draftcount: 22 },
  { month: 'Nov', rescuecount: 32, draftcount: 30 },
  { month: 'Dec', rescuecount: 34, draftcount: 32 },
];

const MonthlyChart = ({ data }) => {

  return (
    <ResponsiveContainer width="100%" height={"100%"}>
      <BarChart
        data={data}
        margin={{
          top: 5,
          right: 30,
          left: 20,
          bottom: 5,
        }}
      >
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="month" />
        <YAxis />
        <Tooltip />
        <Legend />
        <Bar dataKey="rescuecount" name="Rescued Families" fill="#06742f">
          <LabelList dataKey="rescuecount" position="top" />
        </Bar>
        <Bar dataKey="draftcount" name="Draft Families" fill="#444040de">
          <LabelList dataKey="draftcount" position="top" />
        </Bar>
      </BarChart>
    </ResponsiveContainer>
  );
};

export default MonthlyChart;
